import { coreUsersCurrentPicturePutAsyncSlice } from './put';

export const { requestPutCoreUsersCurrentPicture, resetPutCoreUsersCurrentPicture } =
	coreUsersCurrentPicturePutAsyncSlice.asyncActionCreators;
